var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/es6.parse-int.js
// module id = 1283
// module chunks = 168707334958949